// People data.
// One entry per person; the page is served at /p/<slug>.
// Unknown slugs are redirected to the home page by the router.

const people = [
	{
		id: 1,
		slug: 'leo-astorsky',
		name: 'Leo Astorsky',
		role: 'Games, bots and AI things at Anrealm',
		// Optional. Rendered as a single paragraph; newlines are preserved.
		// Carries recognition: someone who met Leo in person remembers a thing he
		// makes, not a job title.
		// Both games are live -- a dead link would defeat the point of naming them.
		bio:
			'Among them a border collie that herds sheep, ' +
			'and a game where a neural net guesses your drawings.',
		// The page is mostly reached by scanning a QR code off a paper card, so
		// the messenger comes first: it is what a stranger actually wants.
		links: [
			{
				id: 1,
				name: 'Telegram',
				icon: 'telegram',
				url: 'https://t.me/leo_astorsky',
			},
			{
				id: 2,
				name: 'Email',
				icon: 'mail',
				url: 'mailto:leo.astorsky@gmail.com',
			},
			{
				id: 3,
				name: 'LinkedIn',
				icon: 'linkedin',
				url: 'https://www.linkedin.com/in/leo-astorsky',
			},
		],
	},
];

var map_people = {};
people.forEach((x) => {
	map_people[x.slug] = x;
});

export default people;
export { map_people };
